import Entity from "../entity";

export default class HZMailBoxs extends Entity<number> {
    Id: string;
    messageId: string;
    mailTitle:string;
    mailDate: string;
    subject: string;
    fromAddress:string;
    toAddress:string;
    isAttachMent: string;
    readFlag: string;
    textBody:string;
    htmlBody:string;
    mailAttachMent:Array<string>;
    letterId:string;
}